import { LoginScreen } from '../services/models/login-screen.model';
import { LoginRequest } from '../services/models/login.request';

export class OpenDialog {
  static readonly type = '[Login] - Open dialog';

  constructor(public screen: LoginScreen) {}
}

export class CloseDialog {
  static readonly type = '[Login] - Close dialog';
}

export class ChangeScreen {
  static readonly type = '[Login] - Change screen';

  constructor(public screen: LoginScreen) {}
}

export class ChangeLastScreen {
  static readonly type = '[Login] - Change last screen';

  constructor(public screen: LoginScreen | string) {}
}

export class VerifyReCaptcha {
  static readonly type = '[Login] - Verify ReCaptcha';

  constructor(public token: string) {}
}

export class RecoverPassword {
  static readonly type = '[Login] - Recover Password';

  constructor(public identifier: string) {}
}

export class Login {
  static readonly type = '[Login] - Login';

  constructor(public request: LoginRequest) {}
}

export class ValidateCode {
  static readonly type = '[Login] - Validate code';

  constructor(public code: string) {}
}

export class Signup {
  static readonly type = '[Login] - Signup';

  constructor(public formModel: any, public multipleId: number) {}
}

export class ExternalLogin {
  static readonly type = '[Login] - External login';

  constructor(public url: string) {}
}
